"use client";

import { useEffect, useState } from "react";

import { Ga4WithEventParameters } from "src/helpers/google-tag-manager/events/ga4-with-eventparameters";

import SubscribeModal from "@/src/components/listing-search/project-radar-banner/ subscribeModal";

import IconLogo from "assets/svg/logo.svg";

import styles from "./styles.module.css";

const ProjectRadarHeader = () => {
  const [isOpen, setIsOpen] = useState(false);

  const subscribeOpenClick = () => {
    window.location.hash = "proje-radari-abone";
    setIsOpen(true);
    setTimeout(() => {
      Ga4WithEventParameters(
        {
          eventName: "proje-radari",
          eventParameters: { label: "abone-ol" },
        },
        300
      );
    });
  };

  const subscribeCloseClick = () => {
    setIsOpen(false);
    window.history.pushState("", document.title, window.location.pathname + window.location.search);
  };

  useEffect(() => {
    if (window.location.hash.length > 0 && window.location.hash === "#proje-radari-abone") {
      setIsOpen(true);
    }
  }, []);

  return (
    <div>
      <header className={styles.header}>
        <a href="/" className={styles.logoWrap}>
          <IconLogo />
        </a>
        <nav className={styles.navLinks}>
          <button className={styles.button} onClick={subscribeOpenClick}>
            Bültene Abone Ol
          </button>
        </nav>
      </header>
      <SubscribeModal isOpen={isOpen} close={subscribeCloseClick} />
    </div>
  );
};

export default ProjectRadarHeader;
